<div class="accessibility-bar">
  <a class="accessibility-bar__skip" href="#main-content" *ngIf="isHomePage">
    <i class="sd sd-chevron-right-double" aria-hidden="true"></i>
    Skip to Main Content
  </a>

  <div class="accessibility-bar__right">
    <a
      class="accessibility-bar__screen-reader"
      routerLink="/screen-reader-access"
      title="Screen Reader Access"
    >
      <i class="sd sd-volume-min" aria-hidden="true"></i>
      Screen Reader Access
    </a>

    <div class="accessibility-bar__font-controls" role="group" aria-label="Adjust text size">
      <button type="button" class="accessibility-bar__font-btn" (click)="increaseFontSize()" aria-label="Increase text size">A+</button>
      <button type="button" class="accessibility-bar__font-btn" (click)="decreaseFontSize()" aria-label="Decrease text size">A-</button>
      <button type="button" class="accessibility-bar__font-btn accessibility-bar__font-btn--reset" (click)="resetFontSize()" aria-label="Reset text size">A</button>
    </div>

    <button
      type="button"
      class="accessibility-bar__contrast-btn"
      (click)="toggleGrayscale()"
      [attr.aria-pressed]="isGrayscale"
      aria-label="Toggle grayscale mode"
      title="Grayscale"
    >
      <i class="sd sd-contrast-01" aria-hidden="true"></i>
    </button>

    <div class="bhashini-plugin-container accessibility-bar__translate"></div>
  </div>
</div>
